
import { Finance } from '../../services/Finance';

function initialState()
{
    return {
        clientWithdrawFee: '',
        clientWithdrawFeeTotal: '',
        clientWithdrawFeeLoading: false,
        buyAirtimeLoading: false,
        compensationLoading: false
    }
}

const getters = {
    clientWithdrawFee: state => state.clientWithdrawFee || 0,
    clientWithdrawFeeTotal: state => state.clientWithdrawFeeTotal || 0,
    clientWithdrawFeeLoading: state => state.clientWithdrawFeeLoading || false,
    compensationLoading: state => state.compensationLoading || false,
    buyAirtimeLoading: state => state.buyAirtimeLoading || false
};

const actions = {
    fetchClientWithdrawFee({ commit }, params) {
        commit('clientWithdrawFeeLoading', true);
        return new Promise((resolve, reject) => {
            Finance.fetchWithdrawFee(params)
                .then(response => {
                    commit('clientWithdrawFee', response.data.fee);
                    commit('clientWithdrawFeeTotal', response.data.total);
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {
                    commit('clientWithdrawFeeLoading', false);
                })
        });
    },
    buyAirtime({ commit }, params) {
        commit('buyAirtimeLoading', true);
        return new Promise((resolve, reject) => {
            Finance.buyAirtime(params)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {
                    commit('buyAirtimeLoading', false);
                })
        });
    },
    updateCompensation({ commit }, params) {
        commit('compensationLoading', true);
        return new Promise((resolve, reject) => {
            Finance.updateCompensation(params)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {
                    commit('compensationLoading', false);
                })
        });
    },
    completeCompensation({ commit }, params) {
        commit('compensationLoading', true);
        return new Promise((resolve, reject) => {
            Finance.completeCompensation(params)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {
                    commit('compensationLoading', false);
                })
        });
    },
    resetState({ commit }) {
        commit('resetState')
    }
};

const mutations = {
    clientWithdrawFee(state, value) {
        state.clientWithdrawFee = value;
    },
    clientWithdrawFeeTotal(state, value) {
        state.clientWithdrawFeeTotal = value;
    },
    clientWithdrawFeeLoading(state, value) {
        state.clientWithdrawFeeLoading = value;
    },
    buyAirtimeLoading(state, value) {
        state.buyAirtimeLoading = value;
    },
    compensationLoading(state, value) {
        state.compensationLoading = value;
    },
    resetState(state) {
        state = Object.assign(state, initialState())
    }
};

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/Finance.js